/**
 * Applicator Reminder — suggests ONE applicator when the cart has lashes but no applicator.
 * - Any Fastbond lash in the cart → Precision Applicator; otherwise → standard Lash Applicator.
 * - Kits that already include an applicator (config includedHandles) never trigger it.
 * - "Has applicator" = any line whose title matches /applicator|tweezer/i.
 * - Dismissible per shopper (localStorage), reset when the cart empties.
 * The returning-customer / kill-switch logic lives in the Liquid snippet (server-side).
 */
(function () {
  var CFG = window.__applicatorReminderCfg || {};
  var roots = document.querySelectorAll('[data-applicator-reminder]');
  if (!roots.length) return;

  var DISMISS_KEY = 'yp_applicator_reminder_dismissed';
  var APPLICATOR_RE = /applicator|tweezer/i;
  var lashTypes = CFG.lashTypes || [];
  var fastbondType = CFG.fastbondType || '';
  var includedHandles = CFG.includedHandles || [];

  function isDismissed() {
    // The dismiss button was removed 2026-08-13 (Shirley) — earlier stored
    // dismissals are ignored so past testers still see the card.
    return false;
  }
  function setDismissed(v) {
    try { v ? localStorage.setItem(DISMISS_KEY, '1') : localStorage.removeItem(DISMISS_KEY); } catch (e) {}
  }

  function render(state, which) {
    for (var i = 0; i < roots.length; i++) {
      roots[i].hidden = !state;
      var opts = roots[i].querySelectorAll('[data-app-option]');
      for (var j = 0; j < opts.length; j++) {
        opts[j].hidden = opts[j].getAttribute('data-app-option') !== which;
      }
    }
  }

  function evaluate(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) { setDismissed(false); render(false, 'standard'); return; }

    var needsApplicator = false, hasApplicator = false, hasFastbond = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var type = it.product_type || '';
      var title = it.product_title || it.title || '';
      var handle = it.handle || '';

      if (APPLICATOR_RE.test(title)) hasApplicator = true;
      if (type === fastbondType) hasFastbond = true;

      if (lashTypes.indexOf(type) !== -1 && includedHandles.indexOf(handle) === -1) {
        needsApplicator = true;
      }
    }

    var which = hasFastbond ? 'precision' : 'standard';
    render(needsApplicator && !hasApplicator && !isDismissed(), which);
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(evaluate)
        .catch(function () {});
    }, 120);
  }

  function addApplicator(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.setAttribute('disabled', '');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        refresh();
      })
      .catch(function () {})
      .then(function () { if (btn) btn.removeAttribute('disabled'); });
  }

  for (var i = 0; i < roots.length; i++) {
    (function (root) {
      var adds = root.querySelectorAll('[data-app-add]');
      for (var j = 0; j < adds.length; j++) {
        adds[j].addEventListener('click', function (e) {
          e.preventDefault();
          addApplicator(this.getAttribute('data-app-add'), this);
        });
      }
      var dismiss = root.querySelector('[data-app-dismiss]');
      if (dismiss) {
        dismiss.addEventListener('click', function (e) {
          e.preventDefault();
          setDismissed(true);
          render(false, 'standard');
        });
      }
    })(roots[i]);
  }

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:build', refresh);
  document.addEventListener('ajaxProduct:added', refresh);

  refresh();
})();
